import { render, staticRenderFns } from "./AddModalmimistator.vue?vue&type=template&id=2f575606&scoped=true"
import script from "./AddModalmimistator.vue?vue&type=script&lang=js"
export * from "./AddModalmimistator.vue?vue&type=script&lang=js"
import style0 from "./AddModalmimistator.vue?vue&type=style&index=0&id=2f575606&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f575606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f575606')) {
      api.createRecord('2f575606', component.options)
    } else {
      api.reload('2f575606', component.options)
    }
    module.hot.accept("./AddModalmimistator.vue?vue&type=template&id=2f575606&scoped=true", function () {
      api.rerender('2f575606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/AddModalmimistator.vue"
export default component.exports